export default class LearningTenantService {
  constructor(baseUri) {
    this.baseUri = baseUri
  }

  async create(learningTenant, options) {
    const response = await fetch(`${this.baseUri}/learning/learningTenant`, {
      body: JSON.stringify(learningTenant),
      headers: {
        'Authorization': `Bearer ${options.accessToken}`,
        'Content-Type': 'application/json'
      },
      method: 'POST'
    })

    return await response.json()
  }

  async delete(id, options) {
    const response = await fetch(`${this.baseUri}/learning/learningTenant/${id}`, {
      headers: {
        'Authorization': `Bearer ${options.accessToken}`
      },
      method: 'DELETE'
    })

    return response.ok
  }

  async find(id, options) {
    try {
      const response = await fetch(`${this.baseUri}/learning/learningTenant/${id}`, {
        headers: {
          'Authorization': `Bearer ${options.accessToken}`
        }
      })

      return await response.json()
    } catch (e) {
      return null
    }
  }

  async getAll(options) {
    const response = await fetch(`${this.baseUri}/learning/learningTenant`, {
      headers: {
        'Authorization': `Bearer ${options.accessToken}`
      }
    })

    return await response.json()
  }

  async update(id, learningTenant, options) {
    const response = await fetch(`${this.baseUri}/learning/learningTenant/${id}`, {
      body: JSON.stringify(learningTenant),
      headers: {
        'Authorization': `Bearer ${options.accessToken}`,
        'Content-Type': 'application/json'
      },
      method: 'PUT'
    })

    return response.ok
  }
}